import { ReactNode } from 'react'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { FieldStyled } from './onboardingStyles'

const ErrorIcon = () => <ErrorOutlineIcon aria-hidden="true" sx={{ fontSize: 15 }} />

interface IField {
  htmlFor?: string
  label?: string
  required?: boolean
  optional?: boolean
  help?: ReactNode
  error?: string
  counter?: { current: number; max: number }
  children: ReactNode
}

export const Field = ({
  htmlFor,
  label,
  required,
  optional,
  help,
  error,
  counter,
  children
}: IField) => (
  <FieldStyled>
    {label ? (
      <label className="label" htmlFor={htmlFor}>
        {label}
        {required ? (
          <span className="req" aria-hidden="true">
            *
          </span>
        ) : null}
        {optional ? <span className="opt">Optional</span> : null}
      </label>
    ) : null}
    {help ? <div className="help">{help}</div> : null}
    {/* Fragment keeps the ReactNode children typed correctly for styled-components. */}
    {/* eslint-disable-next-line react/jsx-no-useless-fragment */}
    <>{children}</>
    {counter ? (
      <div className={counter.current > counter.max * 0.95 ? 'counter warn' : 'counter'}>
        {counter.current} / {counter.max}
      </div>
    ) : null}
    {error ? (
      <div className="err" role="alert">
        <ErrorIcon />
        <span>{error}</span>
      </div>
    ) : null}
  </FieldStyled>
)
